var latinize = require('latinize');

export default {
	
	latinize (value) {
		return latinize(value);
	}
};



// WEBPACK FOOTER //
// ./src/utils/stringUtils.js